export default __webpack_public_path__ + "static/media/large_Stu04.06a2c377.jpg";